<h2 mat-dialog-title>Manage Translations</h2>

<mat-dialog-content class="translation-dialog-content">
	<div class="toolbar-actions" style="margin-bottom: 16px">
		<button mat-raised-button color="primary" (click)="translateAll()" [disabled]="isTranslating">
			<mat-icon>translate</mat-icon>
			Translate All Empty Fields
		</button>
		<span class="spacer"></span>
		<mat-spinner *ngIf="isTranslating" diameter="30"></mat-spinner>
	</div>

	<div class="table-container">
		<table mat-table [dataSource]="translationRows" class="translations-table">
			<!-- Field Column -->
			<ng-container matColumnDef="field">
				<th mat-header-cell *matHeaderCellDef>Field</th>
				<td mat-cell *matCellDef="let row">
					<strong>{{ row.fieldKey || row.fieldId }}</strong>
				</td>
			</ng-container>

			<!-- Property Column -->
			<ng-container matColumnDef="property">
				<th mat-header-cell *matHeaderCellDef>Property</th>
				<td mat-cell *matCellDef="let row">
					<mat-chip>{{ row.property }}</mat-chip>
				</td>
			</ng-container>

			<!-- Dynamic Language Columns -->
			<ng-container *ngFor="let language of languages" [matColumnDef]="language.code">
				<th mat-header-cell *matHeaderCellDef><mat-icon>flag</mat-icon> {{ language.name }}</th>
				<td mat-cell *matCellDef="let row">
					<mat-form-field appearance="outline" style="width: 100%">
						<input
							matInput
							[(ngModel)]="row[language.code]"
							(ngModelChange)="onCellChange(row, language.code, $event)"
							[disabled]="isTranslating"
							[placeholder]="language.code === 'en' ? '' : 'Auto-translate or enter manually'"
						/>
					</mat-form-field>
				</td>
			</ng-container>

			<!-- Actions Column -->
			<ng-container matColumnDef="actions">
				<th mat-header-cell *matHeaderCellDef>Actions</th>
				<td mat-cell *matCellDef="let row">
					<button
						mat-icon-button
						matTooltip="Translate this row"
						(click)="translateRow(row)"
						[disabled]="isTranslating"
					>
						<mat-icon>translate</mat-icon>
					</button>
				</td>
			</ng-container>

			<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
			<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
		</table>
	</div>

	<div *ngIf="translationRows.length === 0" class="no-data">
		<p>No translatable fields found in this form.</p>
	</div>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-button (click)="cancel()" [disabled]="isTranslating">Cancel</button>
	<button mat-raised-button color="primary" (click)="save()" [disabled]="isTranslating || !hasChanges">
		<mat-icon>save</mat-icon>
		Save Translations
	</button>
</mat-dialog-actions>
